import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import addHours from "date-fns/addHours";
import subHours from "date-fns/subHours";

type HourDivition = 1 | 2 | 3 | 4 | 6 | 8 | 12 | 24;

export default function divideHours(
  date: number | Date,
  hours: HourDivition = 1
): Interval[] {
  const unit = 24 / hours;
  const s = startOfDay(date);
  const e = endOfDay(date);
  return new Array(hours).fill(0).map((_, i) => {
    const start = addHours(s, unit * i);
    const end = subHours(e, unit * (hours - i - 1));
    return { start, end };
  });
}
